// TextInput.jsx
import React from "react";

export default function TextInput({
  label,
  helper,
  error,
  icon: Icon,
  rightSlot,
  className = "",
  ...props
}) {
  const ACCENT = "#169FA7";

  return (
    <div className={className}>
      {label && (
        <label className="block text-sm font-medium text-neutral-700 dark:text-neutral-300 text-start mb-1">
          {label}
        </label>
      )}

      <div className="relative">
        {Icon && (
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-neutral-400 dark:text-neutral-500">
            <Icon size={16} />
          </span>
        )}
        <input
          {...props}
          className={[
            "h-11 w-full rounded-full px-3",
            Icon ? "pl-9" : "",
            "bg-white dark:bg-neutral-900",
            "border border-neutral-200 dark:border-neutral-800",
            "text-neutral-900 dark:text-neutral-100 placeholder:text-neutral-400 placeholder:text-sm text-sm",
            "focus:outline-none focus:ring-.5 focus:ring-[--ring] focus:border-[--ring]",
            error ? "ring-rose-500" : "focus:ring-[--ring] focus:border-[--ring]",
          ].join(" ")}
          style={{ "--ring": ACCENT }}
        />
        {rightSlot && (
          <div className="absolute right-2 top-1/2 -translate-y-1/2">
            {rightSlot}
          </div>
        )}
      </div>

      {helper && !error && (
        <p className="mt-1 text-xs text-neutral-500 dark:text-neutral-400 text-start">
          {helper}
        </p>
      )}
      {error && (
        <p className="mt-1 text-xs text-rose-600 dark:text-rose-400 text-start">
          {error}
        </p>
      )}
    </div>
  );
}
